Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.loginAPiEndPoint = "login/login";
exports.loginAPiMethod = "POST";
exports.loginApiContentType = "application/json";
exports.errorPasswordNotValid = "Password not valid.";
exports.placeHolderEmail = "Email";
exports.placeHolderPassword = "Password";
exports.labelHeader = "The reason we require login";
exports.btnTxtLogin = "LOG IN";
exports.labelRememberMe = "Remember me";
exports.btnTxtSocialLogin = "LOGIN WITH SOCIAL MEDIA";
exports.labelOr = "OR";
exports.placeHolderMobile = "Mobile";
exports.labelForgotPassword = "Forgot password ?";
exports.btnTxtEmailLogin = "LOGIN WITH EMAIL";
exports.errorCountryCodeNotSelected = "Please select country code";
exports.errorMobileNoNotValid = "Mobile no. not valid.";
exports.errorTitle = "Error";
exports.labelTitle = "Log in";

exports.forgotPasswordApiEndpoint = "bx_block_forgot_password/reset_password"
exports.resetPasswordApiEndpoint = "bx_block_forgot_password/change_password"

exports.RESET_PASSWORD_TOKEN = "token"
exports.httpPostMethod = "POST"
exports.contactUsText = "Contact Us"
exports.forgotPasswordText = "Forgot Password"
exports.resetPasswordText = "Reset Password"
exports.passwordResetSuccessfulMessage = "Password Reset successful!"
exports.enterYourEmailAddressText = "Please enter your Email Address"
exports.enterYourNewPasswordText = "Please enter your New Password"
exports.resendForgotEmailText = "Resend Forgot Password Link"
exports.sendForgotPassLinkText = "Request Forgot Password Link"
exports.successForgotMailSentMessage1 = "A forgot password link has been sent to your email address ("
exports.successForgotMailSentMessage2 = "). Please check your inbox and click on the link to verify your email and reset your password. If you don't see the email, please check your spam or junk folder. For any issues, contact our support team."
// Customizable Area End
